import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import {
  MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE,
  MASTER_TEMPLATE_COMPONENT_MAPPING,
} from "../../../constants";
import { isDesktop, isLandscape } from "../../../utils";

@inject("BrandStore")
@observer
class ComponentDecider extends Component {
  static decideComponent(componentData) {
    const { type, key } = componentData;
    const mapping = type || key;
    if (
      !isDesktop &&
      !isLandscape &&
      MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE[mapping]
    ) {
      return MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE[mapping];
    }
    return MASTER_TEMPLATE_COMPONENT_MAPPING[mapping];
  }

  constructor() {
    super();
    this.state = { module: null };
    this.currentClass = this.currentClass.bind(this);
    this.init = this.init.bind(this);
  }
  componentDidMount() {
    this.init();
  }
  init() {
    const { componentData, hideComponent } = this.props;
    const pathForFile = ComponentDecider.decideComponent(componentData);
    if (!pathForFile) {
      hideComponent();
    } else {
      import(`../ComponentPool/${pathForFile}/index.js`).then(module => {
        this.setState({ module: module.default });
      });
    }
  }
  currentClass(parentData) {
    return `nw-${this.props.BrandStore.templateType.toLowerCase()}-${this.props.BrandStore.brandId.toLowerCase()}-${(parentData &&
      parentData.type &&
      parentData.type.toLowerCase()) ||
      "section"} nw-${this.props.BrandStore.templateType.toLowerCase()}`;
  }
  render() {
    const {
      componentData,
      parentData,
      hideComponent,
      sectionIndex,
      componentIndex,
    } = this.props;
    const { module: DecidedComponent } = this.state;
    if (!DecidedComponent) {
      return <div />;
    }
    return (
      <DecidedComponent
        data={componentData}
        parentData={parentData}
        className={this.currentClass(parentData)}
        hideComponent={hideComponent}
        sectionIndex={sectionIndex}
        componentIndex={componentIndex}
      />
    );
  }
}

ComponentDecider.propTypes = {
  componentIndex: PropTypes.number.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  hideComponent: PropTypes.func.isRequired,
  componentData: PropTypes.shape({}).isRequired,
  parentData: PropTypes.shape({}).isRequired,
  BrandStore: PropTypes.shape({
    templateType: PropTypes.string.isRequired,
    brandId: PropTypes.string.isRequired,
  }).isRequired,
};

export default ComponentDecider;



// WEBPACK FOOTER //
// ./src/component/MasterTemplate/ComponentDecider/index.js